import React, { FC } from 'react';
import { OptionFieldProps } from '../../common/OptionField';
import { OptionFieldWithAnalytics } from '../../common/OptionFieldWithAnalytics';

export const ResizeAndCropOptionField: FC<OptionFieldProps> = (props) => (
  <OptionFieldWithAnalytics
    {...props}
    eventAction="edit resize and crop"
  />
);
